<!-- F1065-K2 Data Entry Component - Generic for multiple sections -->
<!-- Migrated from AngularJS: ui/app/components/ftc/settings/F1065-k2/FTC1065K2DataEntry.html -->

<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header">
      <b>{{ sectionHeader }}</b>
    </p>

    <div class="table-responsive">
      <table class="table table-striped blue k2-table">
        <thead>
          <tr align="center">
            <!-- Error Column Header -->
            @if (showErrCol) {
<th style="width: 200px;">Error</th>
}
            
            <!-- Line Column -->
            <th class="pl-2 line-col">Line</th>
            
            <!-- Description Column -->
            <th class="pl-2 desc-col">Description</th>
            
            <!-- Data Column Headers -->
            @for (cols of colHeaderData | orderBy:'COL_PRIORITY'; track $index) {
<th
                style="width:120px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span class="mandatory-marker">*</span>
}
            </th>
}
          </tr>
        </thead>

        <tbody>
          @for (x of groupedFormLines | filterBy:'IS_DISPLAY':'Y' | orderBy:['LINE_ORDER', 'SNO']; track trackByRow($index, x)) {
<tr>
            
            <!-- Error Column -->
            @if (showErrCol) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG"></div>
            </td>
}

            <!-- Line Number Column -->
            <td class="line-cell">
              <!-- Add Row Icon -->
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 class="fa fa-plus-circle color-green"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              
              <!-- Delete Row Icon -->
              @if (x.SNO > 0) {
<i
                 class="fa fa-minus-circle color-red"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              
              <!-- Line Number -->
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description Column -->
            <td class="desc-cell">
              <p style="width: 240px;">{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p>
            </td>

            <!-- Data Columns -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol($index, amts)) {
<td
                class="value-cell">
              
              <!-- Hidden ADJ_KEY -->
              <input type="hidden" [value]="amts.ADJ_KEY">

              <!-- NUMERIC Input -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [readonly]="isLastNumericColumn(x.items, amts)"
                     onlyIntegersWithLength
                     (ngModelChange)="calcTotalsCol(x.items)"
                     style="text-align: right;">
}

              <!-- TEXT Input -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH"
                     style="text-align: right;">
}

              <!-- CHECKBOX Input -->
              @if (amts.UI_COMP === 'CHK_BX') {
<input
                     type="checkbox"
                     class="lg-chk"
                     [ngModel]="amts.CELL_VALUE === 'X'"
                     (ngModelChange)="amts.CELL_VALUE = $event ? 'X' : ''"
                     [disabled]="amts.IS_ENABLED === 'N'">
}

              <!-- DATE Input (Enabled) -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED !== 'N') {
<div 
                   class="date-input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': amts.IS_ERROR === 'Y',
                         'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                       }"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       (ngModelChange)="onDateChange(amts, $event)"
                       placeholder="yyyy-mm-dd"
                       style="font-size: 11px;">
              </div>
}

              <!-- DATE Input (Disabled) -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED === 'N') {
<div 
                   class="date-input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngClass]="{'custom-error': amts.IS_ERROR === 'Y'}"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       disabled
                       readonly
                       placeholder="yyyy-mm-dd"
                       style="font-size: 11px;">
              </div>
}

              <!-- DROPDOWN Select -->
              @if (amts.UI_COMP === 'DROP_DOWN') {
<select
                      class="form-control min-ele-wid k2-select"
                      [ngClass]="{
                        'custom-error': amts.IS_ERROR === 'Y',
                        'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                      }"
                      [(ngModel)]="amts.CELL_VALUE"
                      [disabled]="amts.IS_ENABLED === 'N'">
                <option value="">--Select--</option>
                @for (opt of amts.actionData; track $index) {
<option [value]="opt.VALUE">{{ opt.LABEL }}</option>
}
              </select>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

      <!-- Buttons -->
      @if (isAdmin) {
<div class="k2-buttons-container">
        <button class="save-button" type="button" (click)="save()" [disabled]="isSaveClicked">Save</button>
        <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
      </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onSaveConfirm()"
    (cancelled)="onSaveCancel()"
    (closed)="onSaveCancel()">
  </gtw-confirmation-modal>
</div>
}
